module.exports = __webpack_public_path__ + "static/media/axis-editing.c08acb96.svg";